import { z } from 'zod';

const envSchema = z.object({
  appName: z.string().min(1),
  appEnv: z.enum(['development', 'staging', 'production']),
  supabaseUrl: z.string().url(),
  supabaseAnonKey: z.string().min(1),
});

export const env = envSchema.parse({
  appName: import.meta.env['VITE_APP_NAME'],
  appEnv: import.meta.env['VITE_APP_ENV'],
  supabaseUrl: import.meta.env['VITE_SUPABASE_URL'],
  supabaseAnonKey: import.meta.env['VITE_SUPABASE_ANON_KEY'],
});
